import { Module, ActionTree, MutationTree, GetterTree } from "vuex";
import { RootState, PageDataState, pageDataType, PreviewParams } from '../types';
import {
  FETCH_CURRENT_PAGE,
  FETCH_PAGE_BY_ID,
 // FETCH_BLOG_POSTS,
  FETCH_CHILDREN
} from "./actions.names";
import axios from "axios";
import router from "../router/router";
import { API_URL } from "../global";
import { SET_CURRENT_PAGE, CURRENT_PAGE_ERROR } from "./mutations.names";
import { buildParams } from "./../utils/common";
//import { SERCH_STORE } from "./actions.names";

export const state: PageDataState = {
  data: undefined,
  error: false
};

const namespaced: boolean = false;

const getters: GetterTree<PageDataState, RootState> = {
  pageData(state): pageDataType | undefined {
    return state.data;
  },

  pageType(state): string | null {
    if (!state.data) {
      return null;
    }
    const typeString = state.data.meta.type.split(".");
    return typeString[typeString.length - 1];
  }
};

const actions: ActionTree<PageDataState, RootState> = {

  async [FETCH_CURRENT_PAGE]({ commit }, param: string | PreviewParams): Promise<any> {
    return new Promise((resolve, reject) => {
    let url: string;
    if (typeof param == "string") {
      url = `${API_URL}/pages/find/?html_path=${param}`;
    } else {
      url = `${API_URL}/page_preview/1/?content_type=${param.content_type}&token=${param.token}`;
    }
    axios.get(url).then(({ data }) => {
      commit(SET_CURRENT_PAGE, data);
      resolve(data)
        })
        .catch((err: any) => {
          commit(CURRENT_PAGE_ERROR);
          reject(err);
        });
    })

  },
  async [FETCH_PAGE_BY_ID]({ commit }, payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${API_URL}/pages/${payload.id}/${
            payload.params ? "?" + buildParams(payload.params) : ""
          }`
        )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  async [FETCH_CHILDREN]({ commit }, id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${API_URL}/pages/?child_of=${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

};

const mutations: MutationTree<PageDataState> = {
  [SET_CURRENT_PAGE](state, payload: pageDataType) {
    state.error = false;
    state.data = payload;
  },
  [CURRENT_PAGE_ERROR](state) {
    state.data = undefined;
    state.error = true;
  }
};

export const pageData: Module<PageDataState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
